// import { User } from "@api/entities";
import { Store } from "@reduxjs/toolkit";
import { AuthApiService, IAuthApiService } from "../services/auth/auth.api.service";
import { User } from "src/api/entities";

export interface IAuthManager {
    login(email: string, password: string): Promise<User>;
    logout(): Promise<void>;
  }
  
  export class AuthManager implements IAuthManager {
    private static instance: AuthManager;
    private storeManager: Store;
    private authService: IAuthApiService;

    private constructor() {  
      this.authService = AuthApiService.getInstance(
        process.env.REACT_APP_MICROSERVICE_AUTH_BASEPATH!
      );
    }
  
    static getInstance() {
      if (AuthManager.instance == null) {
        AuthManager.instance = new AuthManager();
      }
      return AuthManager.instance;
    }
  
    async login(email: string, password: string): Promise<User> {
      const response = await this.authService.login(email, password)
      return response;
    }

    async logout(): Promise<void> {
      await this.authService.logout();
      window.location.reload()
    }
    
  }
  